import React, { memo } from 'react'

import Header from '../../../components/shared/header/Header'

const HeaderWrapper = (props) => {
  return <Header {...props} />
}

export default memo(HeaderWrapper)
